export enum ScrollDirection {
  PageDown = 'pageDown',
  PageUp = 'pageUp',
}
